"use client";

import React from "react";
import Link from "next/link";
// import { usePathname } from "next/navigation";
import { Typography } from "./ui";
import { env } from "@/lib/environment";
import Image from "next/image";
import { footerSections, footerSocials } from "@/lib/data";
import { MobileStickyCTA } from "./ui/MobileStickyCTA";

// const baseUrl = "https://www.pickcel.com";

// Configuration for available translations per page
// Key: page path, Value: array of available language codes
// const AVAILABLE_TRANSLATIONS: Record<string, string[]> = {
//   // Add page paths and their available translations here
//   // Example:
//   "/": ["es"],
//   // "/pricing": ["es"],
//   // "/company/contact": ["es", "fr", "de"],
// };

// Language configuration
// const LANGUAGES = {
//   es: { name: "Spanish", path: "es" },
//   // Add more languages as needed
// } as const;

// Each footer column renders one or more sections from `footerSections`, stacked.
const FOOTER_COLUMNS: string[][] = [
  ["Product", "Enterprise"],
  ["Solutions"],
  ["Resources", "Company"],
  ["Trust & Compliance", "Partner program"],
];

const SOCIAL_ICONS: Record<string, React.ReactNode> = {
  Facebook: (
    <path
      fill="currentColor"
      d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5.02 3.66 9.18 8.44 9.94v-7.03H8.08v-2.91h2.36V9.83c0-2.34 1.4-3.63 3.52-3.63.7 0 1.64.12 2.08.12v2.29h-1.17c-1.16 0-1.52.72-1.52 1.46v1.76h2.59l-.41 2.91h-2.18V22c4.78-.76 8.44-4.92 8.44-9.94z"
    />
  ),
  LinkedIn: (
    <path
      fill="currentColor"
      d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13zM7.12 20.45H3.56V9h3.56v11.45z"
    />
  ),
  Twitter: (
    <path
      fill="currentColor"
      d="M18.24 2.25h3.31l-7.23 8.26 8.5 11.24h-6.66l-4.71-6.23-5.4 6.23H2.74l7.73-8.84L1.25 2.25h6.83l4.26 5.69 5.9-5.69zm-1.16 17.52h1.83L7.08 4.13H5.12z"
    />
  ),
  YouTube: (
    <path
      fill="currentColor"
      d="M23.5 6.19a3.02 3.02 0 0 0-2.12-2.14C19.5 3.55 12 3.55 12 3.55s-7.5 0-9.38.5A3.02 3.02 0 0 0 .5 6.19C0 8.07 0 12 0 12s0 3.93.5 5.81a3.02 3.02 0 0 0 2.12 2.14c1.88.5 9.38.5 9.38.5s7.5 0 9.38-.5a3.02 3.02 0 0 0 2.12-2.14C24 15.93 24 12 24 12s0-3.93-.5-5.81zM9.55 15.57V8.43L15.82 12l-6.27 3.57z"
    />
  ),
  Instagram: (
    <path
      fill="currentColor"
      d="M12 2.16c3.2 0 3.58.01 4.85.07 3.25.15 4.77 1.69 4.92 4.92.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.15 3.23-1.66 4.77-4.92 4.92-1.27.06-1.64.07-4.85.07s-3.58-.01-4.85-.07c-3.26-.15-4.77-1.7-4.92-4.92C2.17 15.58 2.16 15.2 2.16 12s.01-3.58.07-4.85c.15-3.23 1.66-4.77 4.92-4.92C8.42 2.17 8.8 2.16 12 2.16zM12 0C8.74 0 8.33.01 7.05.07 2.7.27.27 2.69.07 7.05.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.2 4.36 2.62 6.78 6.98 6.98C8.33 23.99 8.74 24 12 24s3.67-.01 4.95-.07c4.35-.2 6.78-2.62 6.98-6.98.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95C23.73 2.7 21.31.27 16.95.07 15.67.01 15.26 0 12 0zm0 5.84a6.16 6.16 0 1 0 0 12.32 6.16 6.16 0 0 0 0-12.32zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.41-11.85a1.44 1.44 0 1 0 0 2.88 1.44 1.44 0 0 0 0-2.88z"
    />
  ),
  Pinterest: (
    <path
      fill="currentColor"
      d="M12 0C5.37 0 0 5.37 0 12c0 5.08 3.16 9.42 7.62 11.16-.1-.95-.2-2.4.04-3.44.22-.94 1.41-5.96 1.41-5.96s-.36-.72-.36-1.78c0-1.66.97-2.91 2.17-2.91 1.02 0 1.52.77 1.52 1.69 0 1.03-.65 2.57-.99 4-.29 1.19.6 2.17 1.78 2.17 2.13 0 3.77-2.25 3.77-5.49 0-2.86-2.06-4.87-5.01-4.87-3.41 0-5.41 2.56-5.41 5.2 0 1.03.39 2.14.89 2.74.1.12.11.22.08.34-.09.38-.29 1.2-.33 1.37-.05.23-.17.27-.4.16-1.5-.69-2.43-2.88-2.43-4.65 0-3.78 2.75-7.25 7.92-7.25 4.16 0 7.39 2.97 7.39 6.92 0 4.14-2.61 7.46-6.23 7.46-1.21 0-2.35-.63-2.76-1.38l-.75 2.85c-.27 1.05-1 2.35-1.5 3.15 1.12.35 2.31.54 3.55.54 6.61 0 11.99-5.37 11.99-11.99C24 5.37 18.63 0 12 0z"
    />
  ),
};

const STAR_PATH =
  "M10 1.5 12.47 6.5l5.53.8-4 3.9.94 5.5L10 14.1 5.06 16.7l.94-5.5-4-3.9 5.53-.8z";

function Stars({ color }: { color: string }) {
  return (
    <span className="flex items-center gap-px" aria-hidden="true">
      {Array.from({ length: 5 }).map((_, i) => (
        <svg key={i} viewBox="0 0 20 20" className="h-3 w-3">
          <path fill={color} d={STAR_PATH} />
        </svg>
      ))}
    </span>
  );
}

const REVIEW_BADGES = [
  {
    name: "Capterra",
    href: "https://www.capterra.com/p/174853/Pickcel/reviews/",
    score: "4.6",
    starColor: "#F5A623",
    mark: (
      <svg viewBox="5 10 41 42" className="h-8 w-8 shrink-0" aria-hidden="true">
        <path fill="#002e47" d="m25 31.9-19.8-6.7 27.6-10.4 13.1-4.9-13.1 41.5z" />
        <path fill="#ff9d28" d="m5.2 25.3h17.2 10.4v-10.3z" />
        <path fill="#69c3ea" d="m32.8 15v36.6l13.1-41.5z" />
        <path fill="#004f80" d="m32.8 25.3h-10.4l10.4 26.3z" />
        <path fill="#e14748" d="m5.2 25.3 19.8 6.8-2.6-6.8z" />
      </svg>
    ),
  },
  {
    name: "G2",
    href: "https://www.g2.com/products/pickcel",
    score: "4.6",
    starColor: "#FF492C",
    mark: (
      <svg viewBox="0 0 24 24" className="h-8 w-8 shrink-0" aria-hidden="true">
        <circle cx="12" cy="12" r="12" fill="#FF492C" />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M12.122 5.143c.45 0 .9.044 1.342.132l-1.342 2.806C9.962 8.08 8.203 9.84 8.203 12s1.76 3.92 3.92 3.92c.937 0 1.844-.338 2.553-.951l1.483 2.572A6.856 6.856 0 0 1 5.266 12a6.856 6.856 0 0 1 6.856-6.856Zm3.498.49a1.262 1.262 0 0 1 .026 0c.427 0 .792.113 1.101.34.31.229.466.546.466.946 0 .639-.36 1.03-1.035 1.376l-.377.191c-.403.204-.602.385-.657.706h2.05v.85h-3.101v-.144c0-.526.103-.96.314-1.306.211-.345.576-.65 1.102-.917l.242-.117c.427-.216.538-.401.538-.625 0-.266-.228-.458-.6-.458-.44 0-.773.228-1.004.694l-.592-.595c.13-.279.338-.502.619-.675a1.7 1.7 0 0 1 .908-.266Zm-2.094 5.388h3.394l1.697 2.937-1.697 2.94-1.697-2.94H11.83l1.696-2.937Z"
        />
      </svg>
    ),
  },
  {
    name: "GoodFirms",
    href: "https://www.goodfirms.co/software/pickcel",
    score: "4.6",
    starColor: "#F5A623",
    mark: (
      <svg viewBox="38.5 23.5 42 43" className="h-8 w-8 shrink-0" aria-hidden="true">
        <path
          fill="#4385F4"
          fillRule="evenodd"
          d="M79 23.6599H49.64C39 26.2599 38.8 35.2999 38.8 35.2999V65.8499H50.09V37.9999C50.084 37.3447 50.3062 36.7079 50.7186 36.1988C51.1311 35.6896 51.7079 35.34 52.35 35.2099H79V23.6599ZM56.69 39.7399C56.69 39.7399 54.4901 39.5199 54.4901 41.5099V50.3599H69V52.9999C69.01 53.1755 68.983 53.3511 68.921 53.5157C68.8589 53.6802 68.7631 53.8299 68.6397 53.9552C68.5163 54.0804 68.3681 54.1785 68.2045 54.243C68.041 54.3076 67.8657 54.3372 67.69 54.3299H54.4901V65.8299H70.3101C70.3101 65.8299 79.9 64.3299 79.98 54.3299V39.7399H56.69Z"
        />
      </svg>
    ),
  },
];

// Line-art glyph shown in the tinted circle beside each section heading.
const SECTION_ICON_PATHS: Record<string, React.ReactNode> = {
  Product: (
    <>
      <path d="M21 8 12 3 3 8v8l9 5 9-5z" />
      <path d="m3 8 9 5 9-5" />
      <path d="M12 13v8" />
    </>
  ),
  Enterprise: (
    <>
      <path d="M3 21h18" />
      <path d="M5 21V7l7-4 7 4v14" />
      <path d="M10 21v-5h4v5" />
    </>
  ),
  Solutions: (
    <>
      <path d="M12 2a6 6 0 0 0-3.5 10.9V16h7v-3.1A6 6 0 0 0 12 2z" />
      <path d="M10 19h4" />
      <path d="M11 22h2" />
    </>
  ),
  Resources: (
    <>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <path d="M14 2v6h6" />
      <path d="M8 13h8" />
      <path d="M8 17h5" />
    </>
  ),
  "Partner program": (
    <>
      <circle cx="9" cy="12" r="5" />
      <circle cx="15" cy="12" r="5" />
    </>
  ),
  "Trust & Compliance": (
    <>
      <path d="M12 3 5 6v6c0 4.4 3 8.3 7 9 4-.7 7-4.6 7-9V6z" />
      <path d="m9 12 2 2 4-4" />
    </>
  ),
  Company: (
    <>
      <path d="M3 21h18" />
      <path d="M4 21V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v16" />
      <path d="M14 9h4a2 2 0 0 1 2 2v10" />
      <path d="M8 7h2M8 11h2M8 15h2" />
    </>
  ),
};

function SectionIcon({ title }: { title: string }) {
  const paths = SECTION_ICON_PATHS[title];
  if (!paths) return null;
  return (
    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent/10">
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        className="h-5 w-5 text-accent"
      >
        {paths}
      </svg>
    </span>
  );
}

// Chevron for in-site links, diagonal arrow for links that leave the site —
// the icon tells you where the row goes before you click it.
function LinkIcon({ external }: { external: boolean }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className="h-3.5 w-3.5 shrink-0 text-gray-400 transition duration-300 group-hover:text-primary motion-safe:group-hover:translate-x-1"
    >
      {external ? (
        <>
          <path d="M7 17 17 7" />
          <path d="M8 7h9v9" />
        </>
      ) : (
        <path d="m9 18 6-6-6-6" />
      )}
    </svg>
  );
}

export default function Footer() {
  // const pathname = usePathname() ?? "/";
  // const [showLangMenu, setShowLangMenu] = useState(false);
  // const availableLanguages = AVAILABLE_TRANSLATIONS[pathname] || [];

  return (
    <footer className="relative isolate overflow-hidden bg-[#f8f9ff]">
      <MobileStickyCTA />

      <div className="container mx-auto px-5 pt-8 sm:px-6 md:px-0">
        <nav aria-label="Footer" className="pb-10 pt-10 md:pb-12">
          <div className="grid grid-cols-1 gap-x-10 gap-y-14 sm:grid-cols-2 lg:grid-cols-4 lg:gap-x-14 xl:gap-x-20">
            {FOOTER_COLUMNS.map(titles => (
              <div key={titles.join("-")} className="flex flex-col gap-12">
                {titles.map(title => {
                  const section = footerSections.find(s => s.title === title);
                  if (!section) return null;
                  return (
                    <div key={title}>
                      <div className="flex items-center gap-3">
                        <SectionIcon title={section.title} />
                        <Typography
                          variant="h2"
                          className="text-base font-bold uppercase tracking-wide text-text-primary"
                        >
                          {section.title}
                        </Typography>
                      </div>
                      <ul className="mt-6 flex flex-col">
                        {section.links.map(link => {
                          const isExternal = link.external ?? link.href.startsWith("http");
                          return (
                            <li
                              key={link.label}
                              className="border-b border-gray-900/8 last:border-0"
                            >
                              <Link
                                href={link.href}
                                target={isExternal ? "_blank" : undefined}
                                rel={isExternal ? (link.rel ?? "noopener noreferrer") : link.rel}
                                className="group -mx-2 flex items-center justify-between gap-6 rounded-md px-2 py-3 text-sm font-normal text-text-primary transition-colors duration-300 hover:text-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                              >
                                <span>{link.label}</span>
                                <LinkIcon external={isExternal} />
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </nav>
      </div>

      <div className="relative">
        <div className="container relative mx-auto px-5 pb-6 pt-4 sm:px-6 md:px-0 md:pt-6">
          <div
            id="footer-cta-sentinel"
            className="relative rounded-2xl bg-white px-6 py-5 shadow-[0_10px_40px_rgba(0,0,0,0.08)]"
          >
          <div className="flex flex-col items-center gap-6 lg:flex-row lg:flex-nowrap lg:justify-between lg:gap-x-6">
            {/* Social links */}
            <div
              aria-label="Pickcel on social media"
              className="flex shrink-0 items-center gap-2"
              role="group"
            >
              {footerSocials.map(social => (
                <Link
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel={social.rel}
                  aria-label={social.label}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-gray-100 text-gray-700 transition-colors duration-300 hover:bg-gray-200 hover:text-text-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                >
                  <svg viewBox="0 0 24 24" aria-hidden="true" className="h-4 w-4">
                    {SOCIAL_ICONS[social.label]}
                  </svg>
                </Link>
              ))}
            </div>

            {/* Review badges — stacked rows on mobile, inline on desktop */}
            <div className="flex w-full flex-col gap-2 sm:w-auto lg:w-auto lg:flex-row lg:flex-nowrap lg:items-center lg:justify-center lg:gap-0 lg:border-l lg:border-gray-200 lg:divide-x lg:divide-gray-200">
              {REVIEW_BADGES.map(badge => (
                <Link
                  key={badge.name}
                  href={badge.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2.5 rounded-md px-5 py-2 transition-opacity duration-300 hover:opacity-80 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary lg:py-0.5"
                  aria-label={`${badge.name} ${badge.score} out of 5`}
                >
                  {badge.mark}
                  <span className="flex flex-col">
                    <span className="text-[13px] font-semibold leading-tight text-text-primary">
                      {badge.name}
                    </span>
                    <span className="mt-0.5 flex items-center gap-1.5">
                      <Stars color={badge.starColor} />
                      <span className="text-[11px] font-medium text-text-secondary">
                        {badge.score}
                      </span>
                    </span>
                  </span>
                </Link>
              ))}
            </div>

            {/* Language
            <div className="relative flex items-center gap-2 lg:border-l lg:border-gray-200 lg:pl-6">
              <Image
                src={env.NEXT_PUBLIC_CDN_URL + "/images/shared/lanugauge.IJntpMHSaESK.svg"}
                alt="Language"
                title="Language"
                width={18}
                height={18}
                loading="lazy"
              />
              {availableLanguages.length > 0 ? (
                <button
                  type="button"
                  onClick={() => setShowLangMenu(open => !open)}
                  className="flex items-center gap-1 text-sm text-text-primary transition-all duration-300"
                >
                  English
                  <span className="text-xs">▾</span>
                </button>
              ) : (
                <span className="text-sm text-text-primary">English</span>
              )}
              {showLangMenu && availableLanguages.length > 0 && (
                <div className="absolute bottom-full right-0 z-20 mb-2 w-32 rounded-md border border-gray-200 bg-white shadow-lg">
                  <Link
                    href="/"
                    className="block px-3 py-2 text-sm text-text-primary hover:bg-gray-50"
                    onClick={() => setShowLangMenu(false)}
                  >
                    English
                  </Link>
                  {availableLanguages.map(langCode => {
                    const language = LANGUAGES[langCode as keyof typeof LANGUAGES];
                    if (!language) return null;
                    return (
                      <Link
                        key={langCode}
                        href={`${baseUrl}/${language.path}${pathname === "/" ? "/" : pathname}`}
                        className="block px-3 py-2 text-sm text-text-primary hover:bg-gray-50"
                        onClick={() => setShowLangMenu(false)}
                      >
                        {language.name}
                      </Link>
                    );
                  })}
                </div>
              )}
            </div>
            */}
          </div>
          </div>

          {/* Copyright */}
          <Typography
            variant="body"
            className="mt-6 text-center text-sm font-light text-text-primary"
          >
            © {new Date().getFullYear()} LaneSquare Technology Pvt Ltd. All rights reserved.
          </Typography>
        </div>
      </div>
    </footer>
  );
}
